import React from 'react';

import classes from './CompanyHeader.module.scss';
import { CompanySubLogo } from '../CompanySubLogo/CompanySubLogo';
import { HeaderBar } from '../HeaderBar/HeaderBar';
import { SwymoLogo } from '../../SwymoLogo/SwymoLogo';

type CompanyHeaderProps = { companyLogoUrl?: string };

const CompanyHeader = ({ companyLogoUrl }: CompanyHeaderProps) => {
  return (
    <HeaderBar inAngularContainer>
      {companyLogoUrl ? (
        <CompanySubLogo logoUrl={companyLogoUrl} />
      ) : (
        <SwymoLogo variant="white" className={classes.logo} />
      )}
    </HeaderBar>
  );
};

export { CompanyHeader };
